import Component from './twitter_instantwin_message_history.vue'
export default Component
